import { render, staticRenderFns } from "./myEditor.vue?vue&type=template&id=136b8e9b"
import script from "./myEditor.vue?vue&type=script&lang=js"
export * from "./myEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./myEditor.vue?vue&type=style&index=1&id=136b8e9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports